import {debounce} from '../_functions'

document.addEventListener("DOMContentLoaded", function (dom) {
    const faqList = dom.target.querySelectorAll('.feed-faq');
    const searchInput = dom.target.querySelector('.js-faq-search-input');

    if (faqList.length && searchInput) {
        const filterFAQ = () => {
            const searchTerm = searchInput.value.trim().toLowerCase();

            faqList.forEach(post => {
                const title = post.querySelector('.js-title');
                const titleText = title ? title.innerText.toLowerCase() : '';
                const content = post.querySelector('.js-content');
                const contentText = content ? content.innerText.toLowerCase() : '';

                var matchSearch = searchTerm === '' || titleText.includes(searchTerm);
                if ( ! matchSearch ) {
                    matchSearch = searchTerm === '' || contentText.includes(searchTerm);
                }

                if (matchSearch) {
                    post.classList.remove('hidden');
                } else {
                    post.classList.add('hidden');
                }
            });
        };

        const handleInput = debounce(filterFAQ, 300);
        searchInput.addEventListener('input', handleInput);

        filterFAQ();
    }
});